// Recovered compiled webpack factory 10276. Edit this function expression; run npm run build.
(e, t, n) => {
  Promise.resolve().then(n.bind(n, 49567));
}
